import axios from 'axios';
import routes from '../app/routes';

const prepareFormDataForSend = (values) => {
  const formData = {
    student_id: values.member,
    body: values.reason,
  };
  return formData;
};

export const claimActions = {
  loadClaims: (dispatch) => {
    axios.get(routes.api.claims.index).then((resp) => {
      dispatch({ type: 'loadClaims', claims: resp.data.data });
    });
  },
  addClaim: (dispatch, values, callback) => {
    axios
      .post(routes.api.claims.create, {
        ...prepareFormDataForSend(values),
      })
      .then((resp) => {
        callback();
      });
  },
  updateClaim: (dispatch, climeId, values, callback) => {
    axios
      .put(routes.api.claims.update(climeId), {
        ...prepareFormDataForSend(values),
      })
      .then((resp) => {
        callback();
      });
  },
  removeClaim: (dispatch, row, callback) => {
    document.querySelectorAll('.tooltip').forEach((el) => {
      el.remove();
    });

    axios.delete(routes.api.claims.destroy(row.id)).then((resp) => {
      callback();
      dispatch({ type: 'removeClaim', claimId: row.id });
    });
  },
  loadMembers: (dispatch) => {
    dispatch({ type: 'loadMembers', members: null });

    axios
      .post(routes.api.students.list, {
        with_all_sessions_delivered: true,
      })
      .then((resp) => {
        dispatch({ type: 'loadMembers', members: resp.data });
      });
  },
};
